var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa8da",
    d: "M11 24 25 2l14 22-14 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986cb",
    d: "m25 2 14 22-14 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa8da",
    d: "m11 27 14 8 14-8-14 19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986cb",
    d: "m25 35 14-8-14 19zM11 24l14-6 14 6-14 8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6bc0",
    d: "m25 18 14 6-14 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthBlue);
export default __webpack_public_path__ + "static/media/ETHBlue.ba1ae9a327fb060f9c0511369d5c351f.svg";
export { ForwardRef as ReactComponent };